module.exports = __webpack_public_path__ + "img/CoverStory.bbaf5e7e.jpg";